<template>
  <div class="app export" :class="{phone:isPhone}" @click="goIndex">
    <div v-if="useNew" class="box has-bg">
      <div class="box-logo has-bg"></div>
      <div class="btn has-bg"></div>
      <div class="has-bg icon-360"></div>
      <div class="car-img-box" :class="carId" v-if="colorTarArr?.length&&timer" >
        <img v-for="(item,index) in colorTarArr" :class="{active:item.code === selectColorCode}"
             v-if="useColorArr.includes(selectColorCode)&&!!item.code"
             :src="require(`../static/exportImg/${carId}/${item.code}.png`)" alt="" class="box-img">
      </div>
      <div class="name" v-if="selectColorItem">{{ selectColorItem.title }}</div>
      <div class="color-box">
        <div class="color" v-for="(item,index) in colorTarArr" :class="{active:item.code === selectColorCode}">
          <div class="has-bg color-inner" v-if="colorImageTar[item.code]"
               :style="{backgroundImage:`url(${colorImageTar[item.code]})`}">
          </div>
          <div class="has-bg color-inner" v-else :style="{background:`${item.color}`}">
            <template v-if="Array.isArray(item.color)">
              <span class="img-child" v-for="c in item.color" :key="c" :style="{background:`${c}`}"></span>
            </template>
          </div>
        </div>
      </div>
    </div>
    <img v-else-if="carId" id="car-img" :src="require(`../static/exportImg/${carId}.jpg`)"/>
  </div>
</template>

<script>
import {getUrlParams, isInIframe} from "@/utils";
import {mapActions, mapState} from "vuex";

const useNewExportCarList = ['rz', 'gx', 'rx', 'nx', 'nx400h', "lx", "es","ls","ux","ex","es200"]
export default {
  data() {
    return {
      CAR: '',
      colorImageTar: {},
      isPhone: window.innerWidth < 767,
      timer:undefined
    }
  },
  computed: {
    ...mapState({
      selectColorCode: state => state.selectColorCode,
      carId: state => state.carConfig.id,
      loadingColorList: state => state.carConfig.loadingColorList,
      selectTypeId: state => state.selectTypeId,
      colorArr: state => state.colorArr,
      colorConfig: state => state.colorConfig,
    }),
    useColorArr: vm => (vm.loadingColorList || vm.colorArr),
    colorTarArr: vm => (vm.loadingColorList || vm.useColorArr).map(code => Object.values(vm.colorConfig).find(o => o.code === code) || {}),
    useNew: vm => useNewExportCarList.includes(vm.carId || vm.CAR),
    selectColorItem: vm => vm.colorConfig[vm.selectColorCode]
  },
  methods: {
    ...mapActions(['initStore', 'setSelectColorCode']),
    goIndex() {
      const tar ={

      }
      const host = location.hostname.includes('dingnatech') ? 'https://uat.lexus.com.cn/models/360/' : 'https://lexus.com.cn/models/360/'
      window.open(host + (tar[this.carId]||this.CAR))
    },
    clearTimer(){
      if(this.timer){
        clearTimeout(this.timer)
        this.timer = undefined
      }
    },
    changeColor(code = this.selectColorCode) {
      if(code){
        this.setSelectColorCode(code)
        this.clearTimer()
        this.timer = setTimeout(() => {
          let nowIndex = this.useColorArr.findIndex(e => e === code)
          nowIndex++
          nowIndex = nowIndex === this.useColorArr.length ? 0 : nowIndex
          this.changeColor(this.useColorArr[nowIndex])
        }, 2500)
      }

    },
    requireImg(color) {
      let path = ''
      try {
        path = require(`assets/color/${color}.png`)
      } catch (e) {
        console.log(e)
      }
      return path
    },
    appRun() {
      this.colorImageTar = this.useColorArr.reduce((prev, item) => {
        const  ph = this.requireImg(item)
        if(ph){
          prev[item] = ph
        }
        return prev
      }, {})
      this.$nextTick(() => {
        this.changeColor()
      })
    },
    initPage() {
      this.initStore(this.CAR).then(this.appRun)
    },
    resize() {
      this.isPhone = window.innerWidth < 767
    },
    visibilitychange(){
      if (document.visibilityState === 'visible') {
        this.changeColor()
      }else {
        this.clearTimer()
      }
    }
  },
  beforeDestroy() {
    this.clearTimer()
    window.removeEventListener('resize', this.resize)
    document.removeEventListener('visibilitychange', this.visibilitychange)
  },
  mounted() {
    this.CAR = getUrlParams().car || 'rz'
    if (this.useNew) {
      this.initPage()
    }
    document.addEventListener('visibilitychange', this.visibilitychange)
    window.addEventListener('resize',this.resize)
  },
}
</script>

<style scoped lang="less">
.has-bg {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.export {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;

  &.phone {

    .box {
      height: 100vh;
      background-image: url("../static/exportImg/phone_bg.png");
      background-size: cover;
      background-position: left top;

      .name {
        font-size: 7vw;
        top: 34vw;
        height: 10vw;
        line-height: 10vw;
        font-weight: 900;
      }

      .box-logo {
        width: 36.19707vw;
        height: 8.8vw;
        top: 8vh;
        left: 5.33vw;
      }

      .btn {
        width: 60vw;
        height: 20vw;
        left: 20vw;
        bottom: 18vw;
      }

      .car-img-box {
        width: 100vw;
        height: 30vh;
        top: 28vh;
        left: 0;
        &.nx,&.nx400h{
          width: 90vw;
        }
        &.gx{
          height: 40vh;
          top: 23vh;
        }
        &.rx,&.ex{
          height: 30vh;
          top: 26vh;
        }

      }

      .icon-360 {
        width: 68vw;
        height: 8.53333vw;
        left: 16vw;
        top: 58vh;
      }

      .color-box {
        width: 86vw;
        height: 7.47vw;
        left: 7vw;
        bottom: 60vw;

        .color {
          width: 6.4vw;
          height: 6.4vw;
          margin-right: 4vw;

          &:last-child {
            margin-right: 0;
          }

          &.active {
            border: 2px solid white;
            width: calc(6.4vw + 4px);
            height: calc(6.4vw + 4px);
          }
        }
      }
    }
  }

  #car-img {
    max-width: 100%;
    max-height: 100%;
  }

  .box {
    width: 100vw;
    height: 46.31579vw;
    background-image: url("../static/exportImg/bg.png");
    background-color: #CBD5E1;
    position: relative;

    .box-logo {
      position: absolute;
      width: 15.11278vw;
      height: 3.65789vw;
      top: 2.71vw;
      left: 2.71vw;
      background-image: url("../static/exportImg/logo.png");
    }

    .btn {
      width: 22vw;
      height: 6vw;
      position: absolute;
      right: 5.41vw;
      bottom: 3.61vw;
      background-image: url("../static/exportImg/btn.png");
    }

    .icon-360 {
      position: absolute;
      width: 19.17293vw;
      height: 2.40602vw;
      left: 40.38vw;
      top: 35.79vw;
      background-image: url("../static/exportImg/icon_360.png");
    }

    .name {
      font-size: 2.10526vw;
      font-style: normal;
      height: 2.56vw;
      line-height: 2.56vw;
      font-family: LEXUS;
      font-weight: 900;
      text-align: center;
      position: absolute;
      top: 2.9vw;
      left: 0;
      width: 100vw;
      background: linear-gradient(180deg, #8F8275 0%, #4A3C30 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .car-img-box {
      width: 63.15789vw;
      height: 25.57895vw;
      position: absolute;
      left: 18.42vw;
      top: 8.22vw;
      display: flex;
      align-items: center;
      justify-content: center;
      &.gx{
        height: 40vw;
      }
      &.rx{
        top: 0vw;
        height: 40vw;
      }

      &.ex{
        top: 6vw;
        height: 30vw;
      }

      .box-img {
        height: 100%;
        width: auto;
        position: absolute;
        opacity: 0;

        &.active {
          opacity: 1;
        }
      }
    }

    .color-box {
      height: 2vw;
      bottom: 3.6vw;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      width: 100vw;

      .color {
        width: 2vw;
        height: 2vw;
        margin-right: 1.5vw;
        border-radius: 50%;

        &.active {
          border: 2px solid white;
          width: calc(2vw + 4px);
          height: calc(2vw + 4px);
        }

        .color-inner {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          //background: #42b983;
          display: flex;
          overflow: hidden;

          .img-child {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>
